import { useState, useEffect } from 'react';
import KeyCodes from 'library/helpers/key-codes';

const useWithA11y = () => {
  const [isTabbing, setIsTabbing] = useState(false);

  const onKeyPress = (event) => {
    /**
     * watch for event.which = 9, a tab keypress event
     * otherwise we are not tabbing and update state accordingly
     */
    if (event.which === KeyCodes.KEY_TAB) {
      setIsTabbing(true);
    } else {
      setIsTabbing(false);
    }
  };

  useEffect(() => {
    window.addEventListener('keyup', onKeyPress);
    return () => {
      window.removeEventListener('keyup', onKeyPress);
    };
  }, []);

  return {
    isTabbing,
  };
};

export default useWithA11y;
